import $ from 'jquery';

export default (props, e) => {
	e.preventDefault();
	$(e.target).closest('.dropdown').toggleClass('opened');
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/dropdownHandler.js